import React, { useEffect, useState } from "react";
import FilterButtonDrawer, {
  FilterDrawerContainer,
  FilterStatusItem,
} from "../../../../../common/components/atom/FilterButtonDrawer/FilterButtonDrawer";
import useStation from "../../../hooks/useStation";
import SingleOrganization from "../../../../organization/components/SingleOrganization";
import { Organization } from "../../../../organization/types/organization.types";
import OrganizationPicker from "../../../../organization/components/OrganizationPicker/OrganizationPicker";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";

export const StationFilterPresenter = () => {
  const {
    getAllStationQuery: {  removeFromFilter , currentFilterObject, setFilterObject },
  } = useStation();
  const [organizationFilter, setOrganizationFilter] = useState<
    Organization | undefined
  >();

  const { userRole } = useAuth();


  useEffect(() => {
    if (organizationFilter) {
      setFilterObject({
        station_organization_id: {
          operator: "eq",
          values: [organizationFilter.organization_id],
          attribute: "station_organization_id",
        },
      });
    }
  }, [organizationFilter]); // eslint-disable-line


  if (userRole && (userRole < userRoles.SUPER_ADMIN)) {
    return <></>
  }
  return (
    <div>
      <FilterButtonDrawer
        label="Filtre"
        childrenRender={({ closeDrawer }) => (
          <FilterDrawerContainer>
            <OrganizationPicker
              label="Organisation"
              setOrganization={setOrganizationFilter}
              currentOrganization={organizationFilter}
              style={{ height: 35, width: 250 }}
            />
          </FilterDrawerContainer>
        )}
        filterStatusRender={
          currentFilterObject?.station_organization_id?.values[0]
            ? () => (
                <>
                  <FilterStatusItem
                    labelRender={() => (
                      <SingleOrganization.Info
                        id={
                          currentFilterObject?.station_organization_id
                            ?.values[0] as string
                        }
                        info="organization_name"
                      />
                    )}
                    onClickDelete={() => {
                      removeFromFilter(["station_organization_id"]);
                      setOrganizationFilter(undefined);
                    }}
                  />
                </>
              )
            : undefined
        }
      />
    </div>
  );
};

export default StationFilterPresenter;
